import { groups } from './core.initialState.groups';
import { parameters } from './core.initialState.parameters';

export const generators: IGenerators = {
  g1: {
    id: 'g1',
    createdAt: '2023-05-16T11:11:22',
    createdBy: 'auth0|61828e43d3603a00690799b1',
    modifiedAt: '2023-05-16T11:11:22',
    name: 'Railway Tracks',
    paletteId: '86bb4405-dc45-416c-ac1d-33eeffe26129',
    tags: ['train', 'rail', 'western', 'transportation'],
    type: 'object',
    visibility: 'public',
    groups,
    parameters,
    defaultValues: {},
  },
};
